import Configuracao from "../misc/Configuracao";
import ProcessoTipoJulgamento, { TipoJulgamentoEnum } from "../modelo/TipoJulgamento";
import fetch from "./AxiosAdapter";
import { apresentarApiErroPadrao } from '@/utils/ApiErroPadraoUtils';

class JulgamentoApi {

    async indicarModalidadeJulgamentoVirtual(identificadoresProcessos: number[], votacaoVirtual: TipoJulgamentoEnum) {
        let result;
        try {
            result = await fetch(Configuracao.urlVotacaoVirtual,
                {
                    method: votacaoVirtual === TipoJulgamentoEnum.VIRTUAL ? 'POST' : 'DELETE',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: identificadoresProcessos
                });
            if (result.status >= 400) {
                if (apresentarApiErroPadrao(result?.data)) {
                    throw result.data;
                }
                const erro = result.data;
                throw new Error(erro ? erro.mensagem : null);
            }
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            throw new Error("Não foi possível gravar o Tipo de Julgamento selecionado. " + erro + " " + (result ? result.statusText : ""));
        }
        return result.data;
    }

    async buscarTipoJulgamento(identificadoresProcessos: number[], sessaoFutura: boolean = false): Promise<ProcessoTipoJulgamento[]> {

        let result;
        try {
            result = await fetch(Configuracao.urlConsultarVotacaoVirtual + "?apenasSessaoFutura=" + sessaoFutura,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    data: identificadoresProcessos
                });
            if (result.status >= 400) {
                if (apresentarApiErroPadrao(result?.data)) {
                    throw result.data;
                }
                const erro = result.data;
                throw new Error(erro ? erro.mensagem : null);
            }
        } catch (erro) {
            if (apresentarApiErroPadrao(erro)) {
                throw erro;
            }
            throw new Error("Não foi possível recuperar o Tipo de Julgamento. Contate o administrador do sistema." + erro + " " + (result ? result.statusText : ""));
        }
        return result?.data;
    }

}

export default new JulgamentoApi();